export default "__VITE_ASSET__BjViiMf1__"